import { render } from "./AdminStatutes.vue?vue&type=template&id=8ef5fe46&scoped=true"
import script from "./AdminStatutes.vue?vue&type=script&lang=js"
export * from "./AdminStatutes.vue?vue&type=script&lang=js"

import "./AdminStatutes.vue?vue&type=style&index=0&id=8ef5fe46&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ef5fe46"]])

export default __exports__